const sidebar = document.getElementById('sidebar');

export function checkIfMarkupOrMeasure() {
      if (sidebar) {
        const active = document.getElementsByClassName("active");
        for (let i = 0; i < active.length; i++) {
          if (active[i].id === "markuptab" || active[i].id === "measuretab") {
            return true;
          }
        }
      } else {
        const popovers = document.querySelectorAll("calcite-popover[aria-hidden=false]");
        if (popovers) {
          popovers.forEach(popover => {
            if (popover.ariaLabel === "Markup" || popover.ariaLabel === "Measure") {
              return true;
            }
          });
        }
      }
      return false;

  }
  
  
  